// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"b8169a6b","372":"8b0e0c9e"}[chunkId] + ".chunk.js";
};